import type { ReactNode } from 'react';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonPage,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import { chevronBackOutline } from 'ionicons/icons';

/** Der Seitengrund. Liegt einmal hinter der ganzen App - eine ruhige helle
    Flaeche, damit die weissen Karten darauf ueberhaupt als Flaechen lesbar
    sind. */
export function Backdrop() {
  return <div className="r2f-backdrop" aria-hidden="true" />;
}

interface PageProps {
  title?: string;
  onBack?: () => void;
  children: ReactNode;
}

/** Einheitliches Seitengerüst: transparente Kopfzeile über dem Verlauf. */
export function Page({ title, onBack, children }: PageProps) {
  return (
    <IonPage>
      {(title || onBack) && (
        <IonHeader className="ion-no-border">
          <IonToolbar>
            {onBack && (
              <IonButtons slot="start">
                <IonButton onClick={onBack} aria-label="Zurück">
                  <IonIcon slot="icon-only" icon={chevronBackOutline} />
                </IonButton>
              </IonButtons>
            )}
            {title && <IonTitle>{title}</IonTitle>}
          </IonToolbar>
        </IonHeader>
      )}
      <IonContent fullscreen>
        <div className="r2f-page r2f-stack">{children}</div>
      </IonContent>
    </IonPage>
  );
}

/** Weisse Karte - die Grundflaeche fuer so ziemlich alles. */
export function Card({ children, flush = false }: { children: ReactNode; flush?: boolean }) {
  return <div className={flush ? 'r2f-card r2f-card--flush' : 'r2f-card'}>{children}</div>;
}
